export const uid = (prefix) => `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

export const emptyModule = () => ({
    id: uid("module"), title: "Новый раздел", description: "", materials: [], questions: [],
});

export const emptyMaterial = () => ({
    id: uid("material"), type: "text", title: "Новый материал", content: "", url: "", required: true,
});

export const emptyQuestion = () => ({
    id: uid("question"), type: "single", text: "", required: true, max_score: 1, weight: 1,
    partial_credit: true, wrong_penalty: 1,
    options: [
        { id: uid("option"), text: "", correct: true },
        { id: uid("option"), text: "", correct: false },
    ],
});

export function latestDraft(course) {
    return course?.versions?.find((item) => item.status === "draft")
        || course?.versions?.find((item) => item.status === "published")
        || null;
}
